import {
  Card,
  CardActions,
  CardContent,
  Divider,
  Skeleton,
  Typography
} from '@mui/material'
import CardIcon from './components/cardIcon'
import { object, string, number, bool } from 'prop-types'
import React from 'react'
import * as sx from './styles'
import { useNavigate } from 'react-router-dom'
import BaseTooltip from '../../BaseTooltip'

const DataCard = ({
  Icon,
  loading = false,
  legend,
  value,
  color = 'gray',
  cardProps = {},
  route,
  simplify = false,
  filterGestao = {},
  descricao
}) => {
  const routerLink = useNavigate()
  function goTo(route) {
    if (!route) return 0

    localStorage.setItem('filterGestao', JSON.stringify(filterGestao))
    routerLink(route)
  }

  function formatarNumero(numero) {
    if (numero >= 1000000) {
      return Math.trunc(numero / 100000) / 10 + 'M'
    } else if (numero >= 1000) {
      return Math.trunc(numero / 100) / 10 + 'k'
    } else {
      return numero.toString()
    }
  }

  function addPoints(value) {
    return (value = value.toLocaleString('pt-BR'))
  }

  const ReduceNumber = () => {
    if (!simplify) return <Typography sx={sx.CardValue}>{value}</Typography>
    return (
      <BaseTooltip
        style={{ fontSize: '2.5rem' }}
        light
        title={addPoints(value)}
      >
        <Typography fontSize={'2.2rem'}>{formatarNumero(value)}</Typography>
      </BaseTooltip>
    )
  }

  return (
    <>
      <Card
        {...cardProps}
        style={route ? sx.cardStyleClickable : sx.cardStyle}
        onClick={() => goTo(route)}
      >
        <CardIcon color={color} sx={sx.cardIconSx}>
          <Icon className="icon-card" />
        </CardIcon>
        <CardContent sx={sx.cardContentSx}>
          {loading ? (
            <Skeleton height={65} width="80%" />
          ) : (
            <ReduceNumber simplify={simplify} value={value} />
          )}
        </CardContent>
        <Divider />
        <CardActions sx={sx.cardActionsSx}>
          {descricao ? (
            <BaseTooltip light title={descricao}>
              <Typography sx={sx.CardLegend}>{legend}</Typography>
            </BaseTooltip>
          ) : (
            <Typography sx={sx.CardLegend}>{legend}</Typography>
          )}
        </CardActions>
      </Card>
    </>
  )
}

DataCard.propTypes = {
  Icon: object,
  value: number,
  legend: string,
  color: string,
  loading: bool,
  cardProps: object,
  route: string,
  simplify: bool,
  filterGestao: object,
  descricao: string
}

export default DataCard
